var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "header-section" },
    [
      _c(
        _vm.component,
        _vm._g(
          _vm._b({ tag: "component" }, "component", _vm.$props, false),
          _vm.$listeners
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }